module.exports = __webpack_public_path__ + "img/Standard.5aff5096.jpg";